const requestHandler = {}

export default requestHandler